import React from "react";
import PropTypes from "prop-types";
import { Redirect } from 'react-router-dom'

import { Mutation } from 'react-apollo'
import login from 'graphql/mutations/login'

// material-ui components
import withStyles from "material-ui/styles/withStyles";
 
// core components
import ProfileCard from "components/Cards/ProfileCard.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
 
import avatar from "assets/img/faces/avatar.jpg";
 
import lockScreenPageStyle from "assets/jss/material-dashboard-pro-react/views/lockScreenPageStyle.jsx";
 
class LockScreenPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: 'cardHidden',
      password: ''
    };
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }

  handleLogin = login => event => {
    event.preventDefault()

    const email = localStorage.getItem('cdpcrm_email')

    if (!email) {
      this.props.history.push('/')
    } else {
      login({
        variables: {
          email,
          password: this.state.password,
        },
      })
    }

    this.setState({
      password: '',
    })
  }

  handleLoggedIn = ({ login: { token, me }}) => {
    localStorage.setItem('cdpcrm_token', token)
    localStorage.setItem('cdpcrm_user', me.nome)
    localStorage.setItem('cdpcrm_role', me.ruolo)
    this.props.history.push('/home')
  }

  handleChangePassword = event => {
    this.setState({
      password: event.target.value
    })
  }

  render() {
    const { classes } = this.props;
    const nomeUtente = localStorage.getItem('cdpcrm_user')

    return (
      <div className={classes.content}>
        <Mutation mutation={login} onCompleted={this.handleLoggedIn}>
          {(login, { data, loading, error }) => (
            <form onSubmit={this.handleLogin(login)}>

              {!!nomeUtente ?
                <ProfileCard
                  customCardClass={
                    classes.customCardClass + " " + classes[this.state.cardAnimaton]
                  }
                  customCardAvatarClass={classes.customCardAvatarClass}
                  customCardFooterClass={classes.customCardFooterClass}
                  title={nomeUtente}
                  avatar={avatar}
                  content={
                    <CustomInput
                      labelText="Inserisci la password"
                      id="password"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: 'password',
                        value: this.state.password,
                        onChange: this.handleChangePassword
                      }}
                    />
                  }
                  footer={
                    <div>
                      {error && <p style={{ color: '#c00' }}>Email o password errate</p>}
                      <Button type="submit" color="rose" round>
                        Sblocca
                      </Button>
                    </div>
                  }
                />
              :
                <Redirect to="/" />
              }
            </form>
          )}
        </Mutation>
      </div>
    );
  }
}
 
LockScreenPage.propTypes = {
  classes: PropTypes.object.isRequired
};
 
export default withStyles(lockScreenPageStyle)(LockScreenPage);


// WEBPACK FOOTER //
// ./src/views/Login/LockScreenPage.jsx